import config from "config";
import { ACL_MODULE_MAPPING } from "../../constants/RouteConstant";
import React from "react";

export const getSendRewardOptions = (moduleAcl) => {
  let moduleAclArray = moduleAcl?.map((item) => item?.module_id);
  return [
    {
      title: "Reward Points",
      url: "xoxo-points",
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT),
    },
    {
      title: "Reward Codes",
      url: "xoxo-code",
      show:
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN),
    },
    {
      title: "Reward Link",
      url: "xoxo-link",
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK),
    },
    {
      title: "Gift Cards",
      url: "generate-brand-voucher",
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO),
    },
  ];
};

export const getEventRewardOptions = (moduleAcl) => {
  let moduleAclArray = moduleAcl?.map((item) => item?.module_id);
  const titleJsx = (
    <>
      Diwali Gifting <img src="/admin/img/svg-icons/Sparkle.svg" />
    </>
  );
  return [
    {
      title: titleJsx,
      url: "holiday-gifting",
      show:
        moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) &&
        config.holidayGifting,
    },
  ];
};

export const getSettingsOptions = (moduleAcl) => {
  let moduleAclArray = moduleAcl?.map((item) => item?.module_id);

  return [
    {
      title: "Account",
      url: "accounts/platform-preferences#account",
      show: true,
    },
    {
      title: "Admins",
      url: "accounts/platform-preferences#admins",
      show: true,
    },
    {
      title: "API",
      url: "accounts/platform-preferences#api",
      show: true,
    },
    {
      title: "Campaign",
      url: "accounts/platform-preferences#catalog",
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.CAMPAIGN),
    },
    {
      title: "Notifications",
      url: "accounts/platform-preferences#communicaton",
      show: true,
    },
    {
      title: "Rewarding",
      url: "accounts/platform-preferences#rewarding",
      show: false,
    },
    {
      title: "Storefront",
      url: "accounts/platform-preferences#storefront",
      show: true,
    },
    {
      title: "Templates",
      url: "accounts/platform-preferences#templates",
      show: moduleAclArray.includes(ACL_MODULE_MAPPING.COMMON),
    },
    {
      title: "Verifications",
      url: "accounts/platform-preferences#verifications",
      show: true,
    },
    {
      title: "Submit KYB",
      url: "accounts/platform-preferences#submit-kyb",
      show: false,
    },
  ];
};

export const getRechargeOptions = () => {
  return [
    {
      title: "Wallet Balance",
      url: "recharge#wallet-balance",
      show: true,
    },
    {
      title: "Transaction History",
      url: "recharge#transaction-history",
      show: true,
    },
    {
      title: "Invoice",
      url: "recharge#invoice",
      show: true,
    },
  ];
};

export const getReportsOptions = (initialData, type) => {
  const options = initialData.map((data) => ({
    title: data.title,
    url: `reports/${type}#${data.title.toLowerCase().replace(/\s+/g, "-")}`,
    show: true,
  }));

  return options;
};
